import React, { ReactNode } from "react";
import "./ResultBlocks.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    children: ReactNode | ReactNode[];
}

export function ResultBlocks({ children }: IProps) {
    const { t } = useTranslation();
    return (
        <div className="result-blocks-wrapper">
            {children}
            <div className="result-blocks-background">
                <svg xmlns="http://www.w3.org/2000/svg" width="841" height="206.192" viewBox="0 0 841 206.192">
                    <rect id="Rectangle_211" data-name="Rectangle 211" width="840" height="184" rx="20" transform="translate(0.5 21.692)" fill="#f07a3d" stroke="#fcee21" strokeMiterlimit="10" strokeWidth="1"/>
                    <path id="Path_83" data-name="Path 83" d="M391.09,912.181H208.91L200,932.373l8.91,20.192H391.09L400,932.373Z" transform="translate(-119.5 -911.681)" fill="#fcac21" stroke="#fcee21" strokeMiterlimit="10" strokeWidth="1"/>
                    <text id="TEST_RESULT" data-name="TEST RESULT" transform="translate(182.713 26.692)" fill="#0b1032" fontSize="18" fontFamily="FranklinGothicATF-Medium, Franklin Gothic ATF" fontWeight="500" letterSpacing="0.05em"><tspan x="-65.07" y="0">{t('game.test-result').toUpperCase()}</tspan></text>
                </svg>
            </div>
        </div>
    )
}
